<template>
  <div class="form-group for_upload_img border p-0 mb-0">
    <mt-editor
      :typeOfEditor="typeOfEditor"
      v-model="qaContent"
      @input="handleInputQaContent"
      @image-added="handleImageAdded"
      ref="MtEditor"
      v-if="!isOldChrome"
    />
    <textarea
      class="form-control bg-light"
      rows="15"
      style="resize: none"
      v-model="qaContent"
      @input="handleInputQaContent"
      v-if="isOldChrome"
    />
    <!-- <p v-show="c_isQaContentBlank" class="text-danger">请填写问题内容</p> -->
  </div>
</template>
<script>
import { QaContentModelMixin } from '@/mixins/QA/Content/model';

import { getIsOldChrome, isAppleSSafari } from '@/utils/browser';

let promiseComponentMtEditor;

const getComponentMtEditor = () => {
  promiseComponentMtEditor = import('@/components/MtEditor.vue');
  return promiseComponentMtEditor;
};

export default {
  name: 'qa-content',

  mixins: [QaContentModelMixin],

  components: {
    'mt-editor': getComponentMtEditor,
  },

  props: {
    value: {
      type: String,
      default: () => '',
    },

    typeOfEditor: {
      type: String,
      default: () => 'EXERCISE_QA',
    },
  },

  data() {
    return {
      isOldChrome: getIsOldChrome(),
      isAppleSSafari: isAppleSSafari(),
    };
  },

  methods: {
    handleInputQaContent() {
      this.$emit('input', this.qaContent);
    },

    handleImageAdded({ uploadQaImg }) {
      this.$emit('image-added', { uploadQaImg });
    },

    async insertCurrentTimeTagAndCapture() {
      await promiseComponentMtEditor;
      await this.$nextTick();
      if (!this.isOldChrome) {
        this.$refs.MtEditor.insertCurrentTimeTag();
        if (!this.isAppleSSafari) {
          this.$refs.MtEditor.insertCurrentCapture();
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped></style>
